import { IntervalModel, PriceModel } from "$models";
import type { PermitPayPreview } from "$apis/parkito2/index.ts";

export default class PermitPayPreviewModel implements PermitPayPreview {
  constructor(private _data: PermitPayPreview) {
  }

  get recurring() {
    if (this._data.recurring) {
      return {
        ...this._data.recurring,
        price: new PriceModel(this._data.recurring.price),
        period: new IntervalModel(this._data.recurring.period),
      };
    } else {
      return undefined;
    }
  }

  get articles() {
    return this._data.articles.map((appp) => ({
      ...appp,
      periodPrice: new PriceModel(appp.periodPrice),
    }));
  }
  get permitId() {
    return this._data.permitId;
  }

  getTotalPrice(): PriceModel {
    return this.articles
      .map((a) => a.periodPrice)
      .reduceRight((lhs, rhs) => lhs.add(rhs));
  }
}
